// extracted by mini-css-extract-plugin
module.exports = {"atom-spacer__container":"atom-spacer_atom-spacer__container__PHplP","shimmer-animation":"atom-spacer_shimmer-animation__OEVg9"};